import React, { useState, useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import { Media } from '../../../../mediaSetting';
import { showOrgUnitShareLinkForWAModal } from 'actions/modal';
import { saveShareLinkMessageForWA } from 'actions/organisation';
import { displayGlobalMessage } from 'actions/globalMessage';
import Info from '../../info';

const RightPanel = (props) => {
  const dispatch = useDispatch();
  const [savingChanges, setSavingChanges] = useState(false);

  const closeModal = () => {
    dispatch(showOrgUnitShareLinkForWAModal(false));
  };

  const saveChange = () => {
    if (!props.textMessageValidState.valid || !props.emailMessageValidState.valid) {
      return;
    }
    setSavingChanges(true);
    let cb = (result, err) => {
      if (result) {
        setSavingChanges(false);
        dispatch(showOrgUnitShareLinkForWAModal(false));
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.OrgUnitShareLinkforWA.SuccessMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      } else {
        setSavingChanges(false);
        if (err === 'FeatureNotAllowed' || err === 'NoNetworkEditPermission') {
          dispatch(showOrgUnitShareLinkForWAModal(false));
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.ShareLinkSharedText.PermissionChange,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: false,
              gotItButtonText: APP.LANGUAGE.ShareLinkSharedText.Refresh,
              gotItCallBack: () => {
                window.location.reload();
              },
            })
          );
        }
      }
    };
    let payload = {
      additionalEmailMessage: props.additionalEmailMessage,
      additionalTextMessage: props.additionalTextMessage,
      staffCanEditMessages: props.canEditMessages,
    };
    dispatch(saveShareLinkMessageForWA(props.networkId, payload, cb));
  };

  const saveClasses =
    'ui labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull ' +
    (!props.textMessageValidState.valid || !props.emailMessageValidState.valid ? 'disable' : '');

  return (
    <React.Fragment>
      <Container fluid as={Media} greaterThanOrEqual="tablet">
        <div className="mrts mrbl max-width">
          <button
            tabIndex="4"
            type="button"
            name="saveBtn"
            data-group="createOrgUnitForm"
            className={savingChanges ? saveClasses + ' loading' : saveClasses}
            onClick={saveChange}
          >
            {APP.LANGUAGE.Save}
            <i className="checkmark icon" />
          </button>
          <button
            tabIndex="5"
            type="button"
            onClick={closeModal}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
        <div className="mrtl">
          <Info
            paragraphs={[
              APP.LANGUAGE.ShareLinkSharedText.InfoText1,
              APP.LANGUAGE.OrgUnitShareLinkforWA.InfoText2,
              APP.LANGUAGE.OrgUnitShareLinkforWA.InfoText3,
            ]}
          />
        </div>
      </Container>
      <Container fluid as={Media} at="mobile">
        <div className="display-flex mrts mrbs max-width pdlm pdrm">
          <button
            tabIndex="4"
            type="button"
            name="saveBtn"
            data-group="createOrgUnitForm"
            className={(savingChanges ? saveClasses + ' loading' : saveClasses) + ' mobile-fixed-footer-btn mrbs mrrm'}
            onClick={saveChange}
          >
            {APP.LANGUAGE.Save}
            <i className="checkmark icon" />
          </button>
          <button
            tabIndex="5"
            type="button"
            onClick={closeModal}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull mobile-fixed-footer-btn"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default RightPanel;
